import React from 'react';
import {connect} from 'react-redux';
import Container from './components/Container.jsx';
import defaultMessages from './i18n/messages.mjs';
import {
  loadBranches, loadEmployeeById,
  loadEmployees, loginEmployee, onLoginFlowChange,
  saveEmployeeProfile,
  searchEmployeeConflicts,
  selectEmployee
} from '../../actions/login-action-creators.mjs';
import {IntlProvider} from 'react-intl';
import loginDefaultState from './util/loginDefaultState.mjs';
import Modal from '@ignitesales/react-modal';
import {getMessages} from '../../i18n/messageUtil.mjs';
import PropTypes from 'prop-types';

const EmployeeLoginFlow = ({locale='en', loginComplete, ...rest}) => {
  const messages = getMessages(locale);
  const i18nMessages = { ...defaultMessages, ...messages };
  return <IntlProvider locale={locale} messages={i18nMessages} wrapRichTextChunksInFragment>
    <Modal
      show={!loginComplete}
      onClose={() => {}}
      className="employee-login"
      nodeId="root"
      closeBtn={<span/>}
    >
      { !loginComplete ? <Container {...rest} /> : null }
    </Modal>
  </IntlProvider>;
};

EmployeeLoginFlow.propTypes = {
  locale: PropTypes.string,
  loginComplete: PropTypes.bool
};

export default connect(state => {
  const employeeLoginState = state.employeeLoginState || loginDefaultState;

  return {
    ...employeeLoginState
  };
}, dispatch => {
  return {
    loadEmployees: searchValue => {
      dispatch(loadEmployees(searchValue));
    },
    loadEmployeeById: searchObj => {
      dispatch(loadEmployeeById(searchObj));
    },
    searchEmployeeConflicts: searchObj => {
      dispatch(searchEmployeeConflicts(searchObj));
    },
    loadBranches: searchValue => {
      dispatch(loadBranches(searchValue));
    },
    saveEmployeeProfile: employee => {
      dispatch(saveEmployeeProfile(employee));
    },
    onEmployeeSelected: employee => {
      dispatch(selectEmployee(employee));
    },
    loginEmployee: profile => {
      dispatch(loginEmployee(profile));
    },
    loginFlowChanged: (stepToAdd='', stepToRemove='', shouldReset=false) => {
      dispatch(onLoginFlowChange({stepToAdd, stepToRemove, shouldReset}));
    }
  };
})(EmployeeLoginFlow);
